import { render, staticRenderFns } from "./ModalSuccessSync.vue?vue&type=template&id=65432dc6&"
import script from "./ModalSuccessSync.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessSync.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuccessSync.vue?vue&type=style&index=0&id=65432dc6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports